export * from '@primeuix/themes/material/timeline';
export { default } from '@primeuix/themes/material/timeline';
